/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable no-nested-ternary */
import { FunctionComponent } from 'react';

import styles from '../AccountCard.module.scss';
import cardChip from './credit-card-chips.svg';
import Icon from '../../Icon/Icon';

export type CreditCardProps = {
  Name: string;
  MaskedCardNumber: string;
  ExpiryMonth: string;
  ExpiryYear: string;
  CreditCardBrand: string;
  IsDefault: boolean;
  IsExpired: boolean;
  IsSelected: boolean;
  OnRemove: () => void;
  OnSetAsDefault: () => void;
  OnSelect: () => void;
};

type FC = FunctionComponent<CreditCardProps>;

const CreditCard: FC = ({
  Name,
  MaskedCardNumber,
  ExpiryMonth,
  ExpiryYear,
  CreditCardBrand,
  IsDefault,
  IsExpired,
  IsSelected,
  OnRemove,
  OnSetAsDefault,
  OnSelect,
}: CreditCardProps) => {
  return (
    <div
      className={[styles.Container, styles.CreditCard, defaultClass(), selectedClass()].join(' ')}
      onClick={() => {
        OnSelect();
      }}
    >
      <div className={styles.Logo}>
        <Icon
          icon={
            CreditCardBrand === 'mastercard'
              ? 'cardMaster'
              : CreditCardBrand === 'visa'
                ? 'cardVisa'
                : CreditCardBrand === 'amex'
                  ? 'cardAE'
                  : CreditCardBrand === 'discover'
                    ? 'cardDiscover'
                    : 'creditCard'
          }
          size="xlg"
          color={IsDefault ? 'none' : 'grey'}
          width="46px"
        />
      </div>
      {IsDefault && IsSelected && <div className={styles.DefaultBank}>Default Card</div>}
      {!IsDefault && IsSelected && (
        <div className={styles.DefaultBank}>
          <div
            onClick={() => {
              OnSetAsDefault();
            }}
          >
            Set as default
          </div>
          <div
            className={styles.DefaultBankRemove}
            onClick={() => {
              OnRemove();
            }}
          >
            Remove
          </div>
        </div>
      )}
      {IsExpired && IsSelected && <div className={styles.Expired}>Expired</div>}
      {IsSelected && <img src={cardChip} alt="Card Chips" className={styles.CardChip} />}
      <div className={styles.InformationElement}>
        <div className={styles.InformationElementLeft}>
          {IsSelected && <div className={styles.Value}>{Name}</div>}
          <div className={styles.Value}>{trimMaskedCard(MaskedCardNumber)}</div>
        </div>

        {IsSelected && (
          <div className={styles.InformationElementRight}>
            <div className={styles.Label}>Expiry Date</div>
            <div className={styles.Value}>
              {ExpiryMonth}/{ExpiryYear}
            </div>
          </div>
        )}
      </div>
    </div>
  );
  function defaultClass(): string {
    return IsDefault ? styles.Default : '';
  }
  function selectedClass(): string {
    return IsSelected ? styles.Selected : '';
  }
  function trimMaskedCard(cardNumber: string): string {
    if (IsSelected) {
      return cardNumber;
    }

    return cardNumber.slice(-9);
  }
};

export default CreditCard;
